// extracted by mini-css-extract-plugin
module.exports = {"tabActions":"style-module__tabActions___bSJo4","end":"style-module__end___1GLjc","spaced":"style-module__spaced___2Ryps"};